





























/* Created- 10 - Sep - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { Auth0CreateDetails } from "../../Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField } from "../../Models/Components.model";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import ButtonList from "../Common/Buttons/ButtonList.vue";
@Component(
	{
		name: "Auth0Wizard",
		components: { ButtonList }

	})
export default class Auth0Wizard extends ParticaBaseForm<Auth0CreateDetails>  {
	private auth0domainconfig =
		{
			props: {
				name: "Auth0 domain for this site.",
				placeholder: "Auth0 domain",
				label: "Auth0 domain",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private auth0tokenconfig =
		{
			props: {
				name: "Auth0 management token for the Auth0 domain",
				placeholder: "Enter token",
				label: "Auth0 management API token",
			} as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

}
